export default "/_next/static/images/product-product-tours-7ad03b2e18f72e7add4be252f28bb0ea.svg";